import {Routes, Route} from "react-router-dom"
import FriendMarketplace from "./components/FriendMarketplace"
import FriendProfile from "./components/FriendProfile"

function App() {

  return (
    <Routes>
      <Route path="/" element={<FriendMarketplace/>}/>
      <Route path="/friend/:id" element={<FriendProfile/>}/>
    </Routes>
  )
}

export default App